import React from "react"
import PropTypes from "prop-types"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import styles from "./ButtonPrimary.module.scss"

const ButtonPrimary = ({ onClick, small, pulse, icon, color, fullWidth, children, className, disabled, openUrl, gotoUrl, isIconRightSide }) => {

  let classes = styles.butt
  if (color === 'red') classes = `${classes} ${styles.butt__red}`
  if (color === 'blue') classes = `${classes} ${styles.butt__blue}`
  if (color === 'teal') classes = `${classes} ${styles.butt__teal}`
  if (color === 'white') classes = `${classes} ${styles.butt__white}`
  if (color === 'grey') classes = `${classes} ${styles.butt__grey}`
  if (color === 'orange') classes = `${classes} ${styles.butt__orange}`
  if (color === 'whiteRed') classes = `${classes} ${styles.butt__whiteRed}`
  if (color === 'clear') classes = `${classes} ${styles.butt__clear}`
  if (fullWidth) classes = `${classes} ${styles.butt__full}`
  if (icon && !isIconRightSide) classes = `${classes} ${styles.butt__icon}`
  if (icon && isIconRightSide) classes = `${classes} ${styles.butt__icon__right}`
  if (className) classes = `${classes} ${className}`
  if (small) classes = `${classes} ${styles.butt__small}`
  if (pulse) classes = `${classes} ${styles.butt__pulse}`

  if (!children) {
    classes = `${classes} ${styles.butt__iconOnly}`
  }

  let textContent = (
    <>
      {(icon && !isIconRightSide) && <FontAwesomeIcon icon={icon} />}
      {children}
      {(icon && isIconRightSide) && <FontAwesomeIcon icon={icon} />}
    </>
  )

  if (gotoUrl) {
    return (
      <a className={classes} href={gotoUrl}>
        {textContent}
      </a>
    )
  } else if (openUrl) {
    return (
      <a className={classes} href={openUrl} target="_blank" rel="noreferrer">
        {textContent}
      </a>
    )
  }
  return (
    <button className={classes} onClick={onClick} disabled={disabled}>
      {textContent}
    </button>
  )
}

ButtonPrimary.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

ButtonPrimary.defaultProps = {
  children: undefined,
  className: undefined
}

export default ButtonPrimary